import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import {
  getMenuItemsAdm,
  getMenuItemsProp,
} from "../constants/itemsActionColumns";
import WORD from "../../../images/WORD.png";
import VIDEO from "../../../images/video.png";
import EXCEL from "../../../images/excel.png";
import PDF from "../../../images/pdf.png";
import JPEG from "../../../images/jpg.png";
import PNG from "../../../images/png.png";
import INDEFINIDO from "../../../images/arquivo.png";
import { Tooltip } from "antd";

import { Avatar } from "antd";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";

import ColumnSearch from "../../../components/ColumnSearch";
import { validateToken } from "../../../components/Globais";

export const Columns = (
  onClick: (e: any) => void,
  setFileName: (e: string) => void,
  setMimeType: (e: string) => void,
  setNomeArquivo: (e: string) => void,
  setArquivoId: (e: number) => void,
  setArquivoCotaUsuarioId: (e: number) => void,
  setPodeExcluir: (e: number) => void
): ColumnsType<any> => {
  const perfil = validateToken()?.nda;

  const items = perfil === 0 ? getMenuItemsProp() : getMenuItemsAdm();

  return [
    {
      title: "Tipo",
      dataIndex: "tipo",
      key: "tipo",
      width: "5%",
      align: "center",

      render: (item, row) =>
        row.tipo === "PDF" ? (
          <Tooltip title="PDF">
            <Avatar src={PDF} />
          </Tooltip>
        ) : row.tipo === "JPEG" ? (
          <Tooltip title="JPEG">
            <Avatar src={JPEG} />
          </Tooltip>
        ) : row.tipo === "PNG" ? (
          <Tooltip title="PNG">
            <Avatar src={PNG} />
          </Tooltip>
        ) : row.tipo === "NEUTRO" ? (
          <Tooltip title="Indefinido">
            <Avatar src={INDEFINIDO} />
          </Tooltip>
        ) : row.tipo === "WORD" ? (
          <Tooltip title="WORD">
            <Avatar src={WORD} />
          </Tooltip>
        ) : row.tipo === "MP4" ? (
          <Tooltip title="VIDEO">
            <Avatar src={VIDEO} />
          </Tooltip>
        ) : row.tipo === "EXCEL" ? (
          <Tooltip title="EXCEL">
            <Avatar src={EXCEL} />
          </Tooltip>
        ) : null,
    },
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome",

      align: "center",
    },
    {
      title: "Tamanho",
      dataIndex: "tamanho",
      key: "tamanho",
      width: "8%",
      align: "center",
    },
    {
      title: "Data inclusão",
      dataIndex: "data_inclusao",
      key: "data_inclusao",
      width: "12%",
      align: "center",
    },
    {
      title: "",
      dataIndex: "podeExcluir",
      key: "podeExcluir",
      width: "5%",
      align: "center",
      //aqui
      render: (item, row) =>
        row.podeExcluir ? (
          <Tooltip title="Pode excluir">
            <LockOpenIcon color="primary" />
          </Tooltip>
        ) : (
          <Tooltip title="Não pode excluir">
            <LockIcon color="primary" />
          </Tooltip>
        ),
    },

    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "8%",
      align: "center",

      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setFileName(row.nomeArquivo);
                setMimeType(row.mimetype);
                setNomeArquivo(row.nome);
                setArquivoId(row.arquivoId);
                setArquivoCotaUsuarioId(row.id);
                setPodeExcluir(row.podeExcluir);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
